import { Component, OnInit } from '@angular/core';
import { Party } from 'src/app/models/party.model';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
  standalone: false
})
export class FaqComponent  implements OnInit {

  public accessibleMode: string = '';
  public parties: Party[] = [];
  public declarationInfo: any = [];
  public isValid: boolean = false;
  public cricketDet: any = [];
  public emailSender: string = '';
  public message: string = '';
  public itemId: string = '';

  constructor() { }

  ngOnInit() {}

}
